// extracted by mini-css-extract-plugin
export default {"geoMap":"styles_geoMap__SAAu+","fullGeoMap":"styles_fullGeoMap__3O0-C"};